export * from './collapse.form.header.component'


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/collapse/child/header/index.ts